import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/SalaryAdvance.api';


export const getsalaryAdvancesRequest = () => ({
  type: actionTypes.GET_SALARY_ADVANCES_REQUEST,
});

export const getsalaryAdvancesSuccess = (maternity) => ({
  type: actionTypes.GET_SALARY_ADVANCES_SUCCESS,
  payload: maternity,
});

export const getsalaryAdvancesFailure = (error) => ({
  type: actionTypes.GET_SALARY_ADVANCES_FAILURE,
  payload: error,
});

export const getSalaryAdvances = (date) => {
  return async (dispatch) => {
    dispatch(getsalaryAdvancesRequest(date));
    try {
      const leaves = await api.fetchSalaryAdvancesData(date);
      dispatch(getsalaryAdvancesSuccess(leaves));
      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getsalaryAdvancesFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updatesalaryAdvancesRequest = (id, maternityData) => ({
  type: actionTypes.UPDATE_SALARY_ADVANCES_REQUEST,
  payload: { id, maternityData },
});

export const updatesalaryAdvancesSuccess = (message) => ({
  type: actionTypes.UPDATE_SALARY_ADVANCES_SUCCESS,
  payload: message,
});

export const updatesalaryAdvancesFailure = (error) => ({
  type: actionTypes.UPDATE_SALARY_ADVANCES_FAILURE,
  payload: error,
});

export const updateSalaryAdvancesById = (id, maternityData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    maternityData.updated_by = user.user_name;

    dispatch(updatesalaryAdvancesRequest(id, maternityData));
    try {
      const response = await api.updateSalaryAdvances(id, maternityData);
      dispatch(updatesalaryAdvancesSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updatesalaryAdvancesFailure(error));
      return { success: false, message: error };
    }
  };
};



export const deletesalaryAdvancesRequest = (id) => ({
  type: actionTypes.DELETE_SALARY_ADVANCES_REQUEST,
  payload: id,
});

export const deletesalaryAdvancesSuccess = (message) => ({
  type: actionTypes.DELETE_SALARY_ADVANCES_SUCCESS,
  payload: message,
});

export const deleteaternityBenefitsFailure = (error) => ({
  type: actionTypes.DELETE_SALARY_ADVANCES_FAILURE,
  payload: error,
});

export const deleteSalaryAdvancesById = (id) => {
  return async (dispatch) => {
    dispatch(deletesalaryAdvancesRequest(id));
    try {
      const response = await api.deleteSalaryAdvances(id);
      dispatch(deletesalaryAdvancesSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};



// export const uploadsalaryAdvancesRequest = (fileData) => ({
//   type: actionTypes.UPLOAD_SALARY_ADVANCES_REQUEST,
//   payload: fileData,
// });

// export const uploadsalaryAdvancesSuccess = (message) => ({
//   type: actionTypes.UPLOAD_SALARY_ADVANCES_SUCCESS,
//   payload: message,
// });

// export const uploadsalaryAdvancesFailure = (error) => ({
//   type: actionTypes.UPLOAD_SALARY_ADVANCES_FAILURE,
//   payload: error,
// });

// export const uploadSalaryAdvancesFile = (fileData) => {
//   return async (dispatch) => {
//     dispatch(uploadsalaryAdvancesRequest(fileData));
//     try {
//       const response = await api.salaryAdvancesUpload(fileData);
//       dispatch(uploadsalaryAdvancesSuccess(response));
//       return { success: true, message: response };
//     } catch (error) {
//       dispatch(uploadsalaryAdvancesFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };



export const uploadsalaryAdvancesRequest = (fileData) => ({
  type: actionTypes.UPLOAD_SALARY_ADVANCES_REQUEST,
  payload: fileData,
});

export const uploadsalaryAdvancesSuccess = (message) => ({
  type: actionTypes.UPLOAD_SALARY_ADVANCES_SUCCESS,
  payload: message,
});

export const uploadsalaryAdvancesFailure = (error) => ({
  type: actionTypes.UPLOAD_SALARY_ADVANCES_FAILURE,
  payload: error,
});

export const uploadSalaryAdvancesFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadsalaryAdvancesRequest(fileData));
    try {
      const response = await api.salaryAdvancesUpload(fileData);
      
      // IMPORTANT: Return the full response object
      // Backend returns 200 status for both full success and partial success
      dispatch(uploadsalaryAdvancesSuccess(response));
      return { success: true, data: response };
      
    } catch (error) {
      // This catches network errors or non-200 status codes
      dispatch(uploadsalaryAdvancesFailure(error));
      
      // Extract error message from response
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};
export const multiDaletesalaryAdvancesRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_SALARY_ADVANCES_REQUEST,
  payload: ids,
});

export const multiDaletesalaryAdvancesSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_SALARY_ADVANCES_SUCCESS,
  payload: message,
});

export const multiDaletesalaryAdvancesFailure = (error) => ({
  type: actionTypes.MULTIDELETE_SALARY_ADVANCES_FAILURE,
  payload: error,
});

export const multiDeleteSalaryAdvances = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaletesalaryAdvancesRequest(ids));
    try {
      const response = await api.multiDeleteSalaryAdvances(ids);
      dispatch(multiDaletesalaryAdvancesSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaletesalaryAdvancesFailure(error));
      return { success: false, message: error };
    }
  };
};


